import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=7135bc1e&"
import script from "./CreateFolder.vue?vue&type=script&lang=ts&"
export * from "./CreateFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports